<template>
    <div>
        <CommonPopupFrame :changeHeight="99" :changeBottom="0" :isOpen="isOpenScheduleDetail" :closeCompleteAction="closeScheduleDetail" :is-back-press-apply="isBackPressApply">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div v-if="Object.keys(scheduleDetail).length !== 0" style="padding-left: 12px; margin-top: 12px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <img @click="closeScheduleDetail" style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                    <div>
                        <div style="display: flex; align-items: center; gap: 6px;">
                            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ scheduleDetail.title }}</div>
                        </div>
                        <div style="font-weight: 500; font-size: 12px; color: #606060; line-height: 20px; display: flex; align-items: center; gap: 4px;">
                            {{ transDate(scheduleDetail.join_begin_date_time) }} {{ transBeginTime(scheduleDetail.join_begin_date_time) + '~' + transEndTime(scheduleDetail.join_end_date_time) }}
                        </div>
                    </div>
                </div>
                <div @click="setIsShowPopmenu" style="padding-right: 12px; display: flex; flex-direction: column; padding-left: 20px; gap: 3px; position: relative;">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <MemberTalkPopMenuOption v-if="isShowPopMenu" :right="10" :top="25" v-bind="popMenuOptions"></MemberTalkPopMenuOption>
                </div>
            </div>
            <div @touchmove.stop="() => { }" v-if="Object.keys(scheduleDetail).length !== 0" style="padding: 12px; overflow-y: scroll; flex: 1; overflow-x: hidden;">
                <div style="font-weight: 500; font-size: 14px; line-height: 24px; margin-bottom: 8px;">{{ scheduleDetail.contents }}</div>
                <div style="display: flex; gap: 8px; align-items: center; margin-top: 7px; border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                        <div style="color: #606060; font-weight: 700; font-size: 12px; white-space: nowrap;">{{ scheduleDetail.theme }}</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                        <div style="color: #606060; font-weight: 700; font-size: 12px; white-space: nowrap;">{{ isNaN(parseInt(scheduleDetail.dues)) ? '참가비 없음' : scheduleDetail.dues + ' 원' | comma }}</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                        <div style="color: #606060; font-weight: 700; font-size: 12px; white-space: nowrap;">{{ (parseInt(scheduleDetail.cur_cnt) - 1) + '/' + (parseInt(scheduleDetail.max_cnt) - 1) + ' 명' }}</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                        <div class="ellipsis" style="color: #606060; font-weight: 700; font-size: 12px;">{{ scheduleDetail.place_name }}</div>
                    </div>
                    <div @click="showInMap" style="font-weight: 500; font-size: 12px; color: var(--color-main); white-space: nowrap;">지도에서 보기</div>
                </div>
                <div style="margin-top: 16px; margin-bottom: 16px;">
                    <div style="font-weight: 700; font-size: 12px;">함께하는 멤버 {{ parseInt(scheduleDetail.cur_cnt) - 1 }}명</div>
                    <div @touchmove.stop="() => { }" class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 25px; margin: 0 -12px; padding: 0 12px; margin-top: 10px">
                        <div style="display: flex; flex-direction: column; align-items: center; border-right: 1px solid #ebebeb; padding-right: 16px;">
                            <div @click="$Util.showProfile(scheduleDetail.creator.member_idx, scheduleDetail.creator.member_type, '', scheduleDetail.creator.is_coach)">
                                <ProfileImage style="width: 40px;" :imagePath="scheduleDetail.creator.image_path"></ProfileImage>
                            </div>
                            <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ scheduleDetail.creator.nic_name }}</div>
                                <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ scheduleDetail.creator.position }}</div>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center;" v-for="each, i in scheduleMembers" :key="i">
                            <div @click="$Util.showProfile(each.member_idx, each.member_type, '', each.is_coach)">
                                <ProfileImage style="width: 40px;" :imagePath="each.image_path"></ProfileImage>
                            </div>
                            <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                                <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ $Util.position_display_str(each.member_type, each.position, each.is_coach) }}</div>
                            </div>
                        </div>
                        <div style="width: 40px; height: 40px; border-radius: 50%; border: 1px solid #d9d9d9; flex-shrink: 0; display: flex; justify-content: center; align-items: center;" v-for="index in new Array(Math.max(parseInt(scheduleDetail.max_cnt) - (scheduleDetail.cur_cnt), 0))" :key="index">
                        </div>
                    </div>
                </div>
                <div style="height: 8px; width: calc(100% + 24px); margin-left: -12px; background-color: #f5f5f5;"></div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 700; font-size: 12px; margin-bottom: 10px;">댓글</div>
                    <div v-for="each, i in replyList" :key="i + 'reply'" style="display: flex; gap: 6px; margin-bottom: 16px; position: relative;">
                        <div style="position: absolute; line-height: 20px; font-size: 12px; color: #606060; font-weight: 500; right: 0;">{{ each.insert_date | agoDateStr }}</div>
                        <div @click="$Util.showProfile(each.writer_idx, each.writer_type, '', each.writer_is_coach)">
                            <ProfileImage style="width: 40px; height: 40px;" :imagePath="each.image_path"></ProfileImage>
                        </div>
                        <div>
                            <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ each.nic_name }} </div>
                                <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ $Util.position_display_str(each.writer_type, each.position, each.writer_is_coach) }}</div>
                            </div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; word-break: break-all;">{{ each.contents }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div @touchmove.stop="() => { }" v-if="Object.keys(scheduleDetail).length !== 0" style="background-color: #fff; padding: 0 12px; padding-bottom: 38px">
                <div v-if="!scheduleDetail.is_me_joined" style="display: flex; gap: 12px; margin-top: 8px;">
                    <div @click="setIsShowReplyInput" style="height: 40px; line-height: 40px; text-align: center; border-radius: 12px; background-color: #ededed; font-size: 14px; flex: 1; font-weight: 500;">{{ isShowReplyInput ? '나중에 하기' : '댓글 달기' }}</div>
                    <div v-if="scheduleDetail.state == JOIN_STATE.OPEN" @click="confirmEnterSchedule" style="height: 40px; line-height: 40px; text-align: center; border-radius: 12px; background-color: #210f03; font-size: 14px; color: #fff; flex: 1; font-weight: 500;">이 스케줄에 함께하기</div>
                </div>
                <div v-if="!isShowReplyInput && !scheduleDetail.is_me_joined" style="margin-top: 12px; line-height: 20px; font-size: 12px; text-align: center; font-weight: 500;">궁금한 내용은 댓글로 물어볼 수 있습니다.<br>참여 시 새로운 멤버를 스케줄에 초대할 수도 있습니다.</div>
                <div v-else style="display:flex; width:100%; padding-top:8px; align-items: flex-end; background-color: white; border-top:1px solid #F5F5F5;">
                    <div style="flex:1; position: relative; display: flex; gap: 8px;">
                        <ProfileImage style="width: 40px; height: 40px" :imagePath="myImage"></ProfileImage>
                        <textarea v-model="replyContents" ref="text_area" class="hide_scroll" rows="1" style=" overflow:hidden; flex:1; overflow-y: scroll; width: 100%; height:40px; background-color: #efefef; resize:none; outline: none; border:0px; padding:10px 15px; border-radius:20px; font-size:14px; padding-right: 40px; line-height:20px; max-height: 350px;" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"'></textarea>
                        <div @click="saveReply">
                            <div v-if="replyContents.length === 0" style="width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background-color: #D9D9D9; border-radius: 50%;">
                                <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                            </div>
                            <div v-else style="width: 32px; background-color: #210f03; display: flex; align-items: center; justify-content: center; height: 32px; border-radius: 50%; display: flex; justify-content: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
                                <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
        <div style="position: relative; z-index: 100;">
            <ShareSchedule :scheduleIdx="scheduleDetail.idx" :isOpen="isShowShareList" :closeCompleteAction="closeShareList"></ShareSchedule>
        </div>
        <transition name="fade2">
            <div v-if="isShowModal" class="pro_modal">
                <div @click="hideModal" v-if="isShowModal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
                <div class="basic_frame" :class="{ open: isShowModal }">
                    <div style="margin-left: -6px;" @click="hideModal">
                        <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                    </div>
                    <div style="">
                        <div style="display: flex; gap: 12px;  margin-top: 20px;">
                            <div class="circle_progress_wrap">
                                <svg class="circle_progress" width="24" height="24" viewBox="0 0 24 24">
                                    <circle class="frame" cx="12" cy="12" r="10" stroke-width="4" />
                                    <circle :style="{ strokeDashoffset: 32.4149 + 'px' }" style="stroke-dasharray: 62.8318px;" class="bar" cx="12" cy="12" r="10" stroke-width="4" />
                                </svg>
                            </div>
                            <div style="display: flex; gap: 4px;">
                                <div>
                                    <img style="width: 17px;" :src="require('@/assets/free_position_pro.png')" alt="">
                                </div>
                                <div>
                                    <div style="font-size:20px; font-weight: 700; line-height: 24px; margin-bottom: 8px;">스케줄 만들고 오픈멤버톡에<br> 공유하기</div>
                                    <div style="font-size: 14px;font-weight: 500;line-height: 24px; color: #606060;">내가만든 스케줄을 오픈멤버톡에 공유하세<br>요. 그리고 1명을 꼭 참여시키세요!</div>
                                </div>
                            </div>
                        </div>
                        <div style="display:flex; flex-direction: column; align-items: center; padding:20px 0px 10px 0px; background-color: #F5F5F5; border-radius:12px; margin-top:20px;">
                            <div style="width:200px; display:flex;">
                                <div style="display:grid; place-items: center;">
                                    <div :style="{ backgroundColor: '#f76a1c' }" style="display:grid;place-items: center; width:40px; height:40px;border-radius:50%; font-size:0px;">
                                        <img :src="require('@/assets/act.png')" style="width:25px; height:20px; ">
                                    </div>
                                </div>
                                <div style="margin-left:10px;">
                                    <div style="color:#808080; font-weight:bold; font-size:12px;">홈 오픈멤버톡 · <span style="">{{ (selectedOpenTalkRegion && selectedOpenTalkRegion.idx ? selectedOpenTalkRegion.member_cnt : 0) | comma }}명</span>
                                    </div>
                                    <div style="color:#210F03; font-size:14px; font-weight:bold; margin-top:10px; ">{{ selectedOpenTalkRegion && selectedOpenTalkRegion.idx ? selectedOpenTalkRegion.do + ' ' + selectedOpenTalkRegion.sigungu + ' ' + selectedOpenTalkRegion.dong + (selectedOpenTalkRegion.ri ? ' ' + selectedOpenTalkRegion.ri : '') : '' }}</div>
                                </div>
                            </div>
                            <div style="margin-top:16px; width:200px; background-color: white; border-radius:12px; font-size:12px; font-weight:500; color:#FF7111; display: grid; place-items: center; height:36px;" @click="shareOpenTalkDirectly">오픈멤버톡에 공유하기</div>
                        </div>
                        <!--<div @click="showShareList" style="border-radius: 30px; margin-top: 20px; margin-bottom: 20px; padding: 10px; background-color: #210f03; color: #fff; line-height: 24px; font-size: 14px; text-align: center; font-weight: 500;">오픈멤버톡에 공유하기</div>-->
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";
import ProfileImage from '@/components/common/ProfileImage';
import ResponseCode from '../../ResponseCode';
import MemberTalkPopMenuOption from '@/components/common/MemberTalkPopMenuOption'
import ShareSchedule from '@/components/common/ShareSchedule'
import { REPORT_TYPE_IDX, JOIN_STATE } from "@/Constants";
import { JOIN_CHAT_TYPE, PUSH_ACTION } from "../../Constants";

export default {
    name: 'MercenaryScheduleDetail',
    components: { CommonPopupFrame, ProfileImage, MemberTalkPopMenuOption, ShareSchedule },
    props: {
        isOpenScheduleDetail: {
            type: Boolean,
            default: false
        },
        closeScheduleDetail: {
            type: Function,
            default: () => { }
        },
        scheduleDetailIdx: {
            type: [Number, String],
            default: -1
        },
        closeMainModal: {
            type: Function,
            default: () => { }
        },
        setCenter: {
            type: Function,
            default: () => { }
        },
        isBackPressApply: {
            type: Boolean,
            default: false,
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            scheduleDetail: {},
            scheduleMembers: [],
            replyList: [],
            isShowReplyInput: false,
            replyContents: '',
            popMenuOptions: {},
            isShowPopMenu: false,
            isShowShareList: false,
            JOIN_STATE: JOIN_STATE,
            isShowModal: false,
            selectedOpenTalkRegion: {},
        }
    },
    computed: {
        myImage() {
            return this.$GlobalStore.loginInfo().image_path
        }
    },
    methods: {
        async shareOpenTalkDirectly() {
            if (!this.selectedOpenTalkRegion.idx) {
                this.$GlobalStore.showAlert('사용할 수 없는 지역입니다.');
                return;
            }

            let chat_idx;

            if (!this.selectedOpenTalkRegion.chat_idx) {
                const res_auth = await this.$Axios.get('/api/chat/auth', { params: { region_code: this.selectedOpenTalkRegion.code } });
                if (res_auth.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res_auth.data.msg);
                    return;
                }
                chat_idx = res_auth.chat.idx;
            } else {
                chat_idx = this.selectedOpenTalkRegion.chat_idx;
            }

            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetailIdx);
            formData.append('chat_idx', chat_idx);
            formData.append('chat_type', JOIN_CHAT_TYPE.OPEN);

            const res = await this.$Axios.post('/api/join/open/schedule/share', formData);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.hideModal();
                window.pushCustomManager.goScreen('empty', chat_idx, PUSH_ACTION.OPEN_TALK, res.data.region_code, '');
                localStorage.setItem('isShared', true)
                localStorage.setItem('isShowSchedulePopup', true)
            }
        },
        async showOpenTalkShareModal() {
            const parameters = {};
            parameters.code = this.$GlobalStore.loginInfo().region_code.slice(0, 8) + '00';
            const res = await this.$Axios.get('/api/region/bycode', { params: parameters });
            this.selectedOpenTalkRegion = res.data.region;
            this.isShowModal = true;
        },
        hideModal() {
            this.isShowModal = false;
        },
        showShareList() {
            this.isShowModal = false
            this.isShowShareList = true
        },
        closeShareList() {
            this.isShowShareList = false
        },
        setIsShowPopmenu() {
            console.log(this.$GlobalStore.loginInfo().idx)
            this.isShowPopMenu = true;
            if (this.scheduleDetail.creator_idx === this.$GlobalStore.loginInfo().idx) {
                this.popMenuOptions = {
                    labelAndAction: [
                        {
                            label: "공유하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_공유하기');
                                this.showShareList()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/share.png"),
                            imageWidth: 12,
                        },
                        {
                            label: "스케줄 수정하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_수정하기');
                                this.showModifySchedule()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/modify_sche.png"),
                            imageWidth: 11,
                        },
                        {
                            label: "스케줄 삭제하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_삭제하기');
                                // this.$GlobalStore.addModal('MemberTalkSetting', { memberTalkIdx: this.init_refer_idx })
                                this.confirmDelete()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/out_schedule.png"),
                            imageWidth: 11,
                        },
                    ],
                    closeAction: () => {
                        this.isShowPopMenu = false;
                    },
                };
            } else if (this.scheduleDetail.is_me_joined && this.scheduleDetail.creator_idx != this.$GlobalStore.loginInfo().idx) {
                this.popMenuOptions = {
                    labelAndAction: [
                        {
                            label: "공유하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_공유하기');
                                this.showShareList()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/share.png"),
                            imageWidth: 12,
                        },
                        {
                            label: "나가기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_나가기');
                                this.confirmOutSchedule()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/out_schedule.png"),
                            imageWidth: 11,
                        },
                        {
                            label: "신고하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_신고하기');
                                // this.$GlobalStore.addModal('MemberTalkSetting', { memberTalkIdx: this.init_refer_idx })
                                this.report()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/report_post.png"),
                            imageWidth: 11,
                            fontColor: 'var(--color-main)'
                        },
                    ],
                    closeAction: () => {
                        this.isShowPopMenu = false;
                    },
                };
            } else {
                this.popMenuOptions = {
                    labelAndAction: [
                        {
                            label: "공유하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_공유하기');
                                this.showShareList()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/share.png"),
                            imageWidth: 12,
                        },
                        {
                            label: "신고하기",
                            action: () => {
                                this.$Util.sendEventClick('스케줄_신고하기');
                                this.report()
                                this.isShowPopMenu = false
                            },
                            imagePath: require("@/assets/img/report_post.png"),
                            imageWidth: 11,
                            fontColor: 'var(--color-main)'
                        },
                    ],
                    closeAction: () => {
                        this.isShowPopMenu = false;
                    },
                };
            }

        },
        showModifySchedule() {
            this.$GlobalStore.addModal('NewMakeMercenarySchedule', {
                joinIdx: 0, isOpen: true, scheduleIdx: this.scheduleDetail.idx,
                completeAction: () => {
                    this.getScheduleDetail()
                }
            })
        },
        confirmDelete() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄을 삭제할까요?</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>멤버를 모집중인 스케줄입니다.<br>스케줄을 삭제할까요?</div>`;
            this.$GlobalStore.showConfirm(html, () => {
                this.deleteSchedule()
            }, '스케줄 삭제하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        async deleteSchedule() {
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetail.idx)
            const res = await this.$Axios.post('/api/join/schedule/delete', formData);
            if (res.data.code === 0) {
                this.$GlobalStore.hideProgress()
                this.closeScheduleDetail()
                this.completeAction()
            }
        },
        confirmOutSchedule() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄을 나갈까요?</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>이번 스케줄은 참여가 어려우신가보네요<br> 스케줄을 나갈까요?</div>`;
            this.$GlobalStore.showConfirm(html, () => {
                this.outSchedule()
            }, '나가기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        async outSchedule() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetail.idx)

            const res = await this.$Axios.post('/api/join/schedule/exit', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === 0) {
                this.getScheduleDetail()
            }
        },
        report() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">게시물을 신고할까요?</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br> 좋지 않은 게시물을 신고할 수 있어요.<br> 신고를 진행할까요?</div>`;
            this.$GlobalStore.showConfirm(html, async () => {
                this.$Util.sendEventClick('사커하우_게시물신고')
                this.$GlobalStore.addModal('ReportPopup',
                    {
                        target_member_idx: this.scheduleDetail.creator_idx, target_member_type: this.scheduleDetail.creator_type, refer_type: REPORT_TYPE_IDX.SCHEDULE,
                        refer_idx: this.scheduleDetail.idx,
                        report_title: this.scheduleDetail.title, report_contents: this.scheduleDetail.contents, transitionName: 'bottom', isModalBackTransparent: true
                    });
            }, '신고하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        showInMap() {
            // if (this.$route.path === '/view/mercenary') {
            // console.log('실행 1');
            // this.closeScheduleDetail()
            // this.closeMainModal()
            // // this.setCenter(this.scheduleDetail.gps_latitude, this.scheduleDetail.gps_longitude, this.scheduleMembers);
            // this.setCenter(this.scheduleDetailIdx);

            // } else {
            //     this.$GlobalStore.closeModalAll();
            //     this.$GlobalRouter.push('/view/mercenary?time=' + new Date().getTime() + '&schedule_idx=' + this.scheduleDetailIdx + '&type=place');
            // }
            this.$GlobalStore.closeModalAll();
            this.$GlobalRouter.push('/view/mercenary_map?time=' + new Date().getTime() + '&schedule_idx=' + this.scheduleDetailIdx + '&type=place');
        },
        setIsShowReplyInput() {
            // if (!this.scheduleDetail.is_me_joined) {
            //     const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄 멤버만 댓글로 소통할 수 있습니다.</div>`;
            //     this.$GlobalStore.showConfirm(html, () => {
            //
            //     }, '확인', null, this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
            //     return
            // }
            this.isShowReplyInput = !this.isShowReplyInput
        },
        confirmEnterSchedule() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄에 참여하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>참여시 댓글로 소통할 수 있습니다.<br>이 스케줄에 참여할까요?</div>`

            this.$GlobalStore.showConfirm(html, () => {
                this.enterSchedule()
            }, '참여하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
        },
        async enterSchedule() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetailIdx)

            const res = await this.$Axios.post('/api/join/schedule/apply', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getScheduleDetail()
            } else if (res.data.code === ResponseCode.FAIL) {
                const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄에 참여할 수 없습니다</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>진행중이거나 모집이 완료된 스케줄이기 때문에<br>해당 스케줄에 참여할 수 없습니다.</div>`

                this.$GlobalStore.showConfirm(html, () => {

                }, null, '확인', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
            }
        },
        async getScheduleDetail() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleDetailIdx;
            parameters.is_visit = true;

            const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
            if (!res.data.join_schedules) {
                this.$GlobalStore.showAlert('삭제된 스케줄입니다.');
                this.closeScheduleDetail();
                return
            }

            const scheduleDetail = res.data.join_schedules
            const scheduleMembers = res.data.join_schedule_members

            this.scheduleDetail = scheduleDetail
            this.scheduleMembers = scheduleMembers
            this.scheduleMembers = this.scheduleMembers.filter(item => item.member_idx != this.scheduleDetail.creator.member_idx)
            if (this.$GlobalStore.loginInfo().idx == this.scheduleDetail.creator.member_idx) {
                this.checkCondition()
            }
        },
        async getReplyList() {
            const parameters = {}
            parameters.parentIdx = this.scheduleDetailIdx
            parameters.replyDeep = 1
            parameters.parent_type = 'schedule'
            parameters.child_type = 'schedule'

            const res = await this.$Axios.get('/api/soccerhow/replies', { params: parameters })
            this.replyList = res.data.replies
        },
        async saveReply() {
            if (this.replyContents.length === 0) {
                this.$GlobalStore.showAlert('내용을 입력해주세요.')
                return
            }
            const formData = new FormData()
            formData.append('parentIdx', this.scheduleDetailIdx)
            formData.append('contents', this.replyContents)
            formData.append('type', 'schedule')
            formData.append('mode', 'insert')

            const res = await this.$Axios.post('/api/soccerhow/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.replyContents = ''
                this.getReplyList()
                this.$refs.text_area.style.height = ''
            }
        },
        transDate(date) {
            if (date) {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)
                return transDate.join(' ')
            } else {
                return ''
            }
        },
        transBeginTime(time) {
            if (time) {
                return time.split(' ')[1].substring(0, 5)
            } else {
                return ''
            }
        },
        transEndTime(time) {
            if (time) {
                return time.split(' ')[1].substring(0, 5)
            } else {
                return ''
            }
        },
        async checkCondition() {
            const res = await this.$Axios.get('/api/position/free/check')
            const isShared = JSON.parse(localStorage.getItem('isShared'))

            if (!res.data.isShareComplete && !isShared) {
                this.showOpenTalkShareModal()
            } else if (!res.data.isShareComplete && isShared) {
                this.$GlobalStore.setIsShowCompleteProCondition()
            } else if (res.data.isShareComplete) {
                localStorage.removeItem('isShared')
            }
            // this.isScheduleComplete = false
            // this.isShareComplete = false
        },
    },
    watch: {
        isOpenScheduleDetail(newVal) {
            if (newVal) {
                this.getScheduleDetail()
                this.getReplyList()
            } else {
                this.scheduleDetail = {}
                this.scheduleMembers = {}
                this.replyContents = ''
            }
        }
    },
    created() {
        this.shareOpenTalkDirectly = this.$Once(this.shareOpenTalkDirectly);
    }
}
</script>

<style scoped>
.circle_progress_wrap {
    position: relative;
    width: 24px;
    height: 24px;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.circle_progress {
    transform: rotate(-90deg);
}

.frame,
.bar {
    fill: none;
}

.frame {
    stroke: #ebebeb;
}

.bar {
    stroke: var(--color-main);
    stroke-linecap: round;
}

.value {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    color: #888;
    font-size: 16px;
    line-height: 120px;
}

.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}

.pro_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 10;
}

.basic_frame {
    width: 342px;
    background-color: #fff;
    padding: 20px 24px;
    border-radius: 24px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
}

.basic_frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade2-enter-active,
.fade2-leave-active {
    transition: all .5s;
}

.fade2-enter,
.fade2-leave-to {
    top: 100%;
    opacity: 0;
}
</style>